import { WORKING_ORDER_STATE } from "constants/action-types";
import type { IOrder } from "records/order";
import type { IReplenishment, IWarehouse } from "types/inventory";
import { IProduct } from "types/product";
import { ICartAvailability } from "types/availability";

export interface UpdateWorkingOrderStateAction {
    type: typeof WORKING_ORDER_STATE.UPDATE;
    payload: {
        replenishments?: IReplenishment[];
        cartGridView?: boolean;
        exportTemplates?: boolean;
        warehouses?: IWarehouse[];
        carriers?: boolean;
        shippingRates?: boolean;
        products?: IProduct[];
        availability?: ICartAvailability;
    };
    meta?: Record<string, any>;
}

export const updateWorkingOrderState = (
    payload: UpdateWorkingOrderStateAction["payload"],
    meta?: UpdateWorkingOrderStateAction["meta"],
): UpdateWorkingOrderStateAction => ({
    type: WORKING_ORDER_STATE.UPDATE,
    payload: payload,
    meta: meta ?? {},
});

export interface LoadWorkingOrderAction {
    type: typeof WORKING_ORDER_STATE.LOAD;
    payload: {
        view?: string;
        brandChanged?: boolean;
        lineItemId?: string; // line item _id to focus on Working order open
        open?: boolean;
    };
}

/** Should be triggered, when clicking on cart icon, or navigating to the cart page */
export const openWorkingOrder = (payload: LoadWorkingOrderAction["payload"]) => ({
    type: WORKING_ORDER_STATE.OPEN,
    payload,
});

/** Should be triggered, when it is required to load the Legacy Iframe. */
export const loadWorkingOrder = (payload: LoadWorkingOrderAction["payload"]): LoadWorkingOrderAction => ({
    type: WORKING_ORDER_STATE.LOAD,
    payload,
});

/** Should be triggered, when it is required to close Working Order */
export const closeWorkingOrder = (payload?: LoadWorkingOrderAction["payload"]) => ({
    type: WORKING_ORDER_STATE.CLOSE,
    payload,
});

export interface IReviewTabStateAction {
    type: string;
    payload: {
        order?: IOrder;
    };
    meta?: Record<string, any>;
}

export const loadReviewTabState = (
    payload: IReviewTabStateAction["payload"],
    meta: IReviewTabStateAction["meta"] = {},
): IReviewTabStateAction => ({
    type: WORKING_ORDER_STATE.REVIEW.LOAD,
    payload,
    meta,
});

export const updateReviewTabState = (payload: any, meta: Record<string, any>) => ({
    type: WORKING_ORDER_STATE.REVIEW.UPDATE,
    payload,
    meta,
});
